// extracted by mini-css-extract-plugin
export default {"product-item":"ProductItem_product-item__7plG-","product-item-name":"ProductItem_product-item-name__UHTU2","product-item-price":"ProductItem_product-item-price__znhiV"};